import { paths } from "~/router/paths";

export const excludePaths: string[] = [
  paths.auth.store_login,
  paths.auth.login,
  paths.auth.register,
  paths.auth.forgot,
  paths.checkout.index,
  paths.settings.index,
  paths.checkout.index.replace(":id", ""),
];

// Guest-only pages where a dead session shouldn't trigger a redirect to
// login. Deliberately narrower than excludePaths: settings/checkout are
// authenticated pages, so an invalid session there must still sign out.
export const signOutExcludedPaths: string[] = [
  paths.auth.store_login,
  paths.auth.login,
  paths.auth.register,
  paths.auth.forgot,
];

export const notLoggedInPaths: string[] = [
  paths.app.home_login,
  paths.auth.store_login,
  paths.auth.login,
  paths.auth.register,
  paths.auth.forgot,
  paths.checkout.index.replace(":id", ""),
  paths.settings.index,
];
